import { z } from 'zod';
import { UseSchema } from '../../common';

export const projectCloneDtoSchema = z.object({
  name: z.string().max(255).nullable().default(null).describe('The name of the project'),
  projectId: z.string().describe('The ID of the project'),
  captchaToken: z.string().optional().describe('The captcha token'),
});

@UseSchema(projectCloneDtoSchema)
export class ProjectCloneDto {}
export interface ProjectCloneDto extends z.input<typeof projectCloneDtoSchema> {}
